export const handleChangeProfileData = (info) => ({
    type: 'CHANGE_PROFILE_DATA', info
});

export const handleChangeToken = (token) => ({
    type: 'CHANGE_TOKEN', token
});

export const handleSetActiveAddress = (activeAddress) => ({
    type: 'SET_USER_ACTIVE_ADDRESS', activeAddress
});

export const actionLogOutUser = (token) => ({
    type: 'LOG_OUT_USER', token
});